import { onInitService } from "./init-service";
import { LayoutProvider } from "./state/LayoutProvider";
import { MenuProvider } from "./state/MenuProvider";
import { Layout } from "./containers/Layout";

export { useLayout } from "./state/use-layout";
export { useMenu } from "./hooks/use-menu";
export { useHideSideNav } from "./hooks/use-hide-side-nav";
export { useSideNavIsVisible } from "./hooks/use-side-nav-is-visible";
export { withHiddenSideNav } from "./hoc/with-hidden-side-nav";
export { withSideNav } from "./hoc/with-side-nav";
export { LayoutProvider, LayoutContext } from "./state/LayoutProvider";
export { MenuProvider } from "./state/MenuProvider";

export const serviceLayout = ({ registerTargets }) => {
  registerTargets({
    ONE_LAYOUT_TITLE: "one/layout/title",
    ONE_TOOLBAR_CONTENT_LEFT: "one/layout/header/content/left",
    ONE_TOOLBAR_CONTENT_RIGHT: "one/layout/header/content/right",
    ONE_LAYOUT_ROUTE: "one/layout/route",
    ONE_LAYOUT_ROUTES_BEFORE: "one/layout/route/before",
    ONE_LAYOUT_ROUTES_AFTER: "one/layout/route/after",
    ONE_LAYOUT_404: "one/layout/404",
    ONE_LAYOUT_NAV_CONTENT: "one/layout/nav/content",
    ONE_LAYOUT_NAV_OPEN: "one/layout/nav/open",
    ONE_LAYOUT_NAV_HIDDEN: "one/layout/nav/hidden"
  });

  return [
    {
      target: "$INIT_SERVICE",
      handler: onInitService
    },
    {
      target: "$REACT_ROOT_WRAPPER",
      handler: { component: LayoutProvider }
    },
    {
      target: "$REACT_ROOT_WRAPPER",
      handler: { component: MenuProvider }
    },
    {
      target: "$REACT_ROOT_COMPONENT",
      handler: { component: Layout }
    }
  ];
};
